var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _circle2, _path9, _circle3, _circle4, _circle5, _circle6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorBoundaryDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 110,
    viewBox: "0 0 307 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    width: 126,
    height: 80,
    rx: 1,
    fill: "#EFADA8",
    fillOpacity: 0.57
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 90,
    y: 16,
    width: 133,
    height: 76,
    rx: 1,
    fill: "url(#paint0_linear_29_2337)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 30,
    width: 126,
    height: 80,
    rx: 1,
    fill: "url(#paint1_linear_29_2337)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 36.4167,
    width: 8,
    height: 7.60494,
    rx: 1,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 36.4167,
    width: 8,
    height: 7.60494,
    rx: 1,
    fill: "white",
    fillOpacity: 0.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 36.4167,
    width: 8,
    height: 7.60494,
    rx: 1,
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 201,
    y: 36.4167,
    width: 28,
    height: 7.48611,
    rx: 1,
    fill: "#FFB6C3",
    fillOpacity: 0.45
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.998 69.982L167.552 81.2604H169.427L170.005 69.982H166.998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167.429 85.2264C167.717 85.5138 168.062 85.6575 168.465 85.6575C168.848 85.6575 169.185 85.5154 169.476 85.2313C169.767 84.9472 169.912 84.6037 169.912 84.2006C169.912 83.791 169.768 83.4458 169.481 83.165C169.194 82.8841 168.855 82.7437 168.465 82.7437C168.062 82.7437 167.717 82.8858 167.429 83.1699C167.142 83.454 166.998 83.7976 166.998 84.2006C166.998 84.5971 167.142 84.939 167.429 85.2264Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.5 59.1562C169.769 59.1562 170.937 59.8496 171.545 60.964L185.42 86.4015C186.006 87.4762 185.983 88.7804 185.358 89.8332C184.733 90.8859 183.599 91.5312 182.375 91.5312H154.625C153.401 91.5312 152.267 90.8859 151.642 89.8332C151.017 88.7804 150.994 87.4762 151.58 86.4015L165.455 60.964C166.063 59.8496 167.231 59.1562 168.5 59.1562ZM154.625 88.0625H182.375L168.5 62.625L154.625 88.0625Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M240 58H306",
    stroke: "#D30602",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M264 71H291",
    stroke: "#D30602",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M240 86H273",
    stroke: "#D30602",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25 14L59 14",
    stroke: "#D30602",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 14,
    r: 2,
    fill: "#D30602"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 30L44 30",
    stroke: "#D30602",
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 30,
    r: 2,
    fill: "#D30602"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28 43L52 43",
    stroke: "#D30602",
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 43,
    r: 2,
    fill: "#D30602"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 71,
    r: 2,
    fill: "#D30602"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 58,
    r: 2,
    fill: "#D30602"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 273,
    cy: 86,
    r: 2,
    fill: "#D30602"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_2337",
    x1: 90,
    y1: 33,
    x2: 299,
    y2: -27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE93A3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29_2337",
    x1: 178,
    y1: 110,
    x2: 109.376,
    y2: 40.6485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B32A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B32A3A",
    stopOpacity: 0.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorBoundaryDefault);
export default __webpack_public_path__ + "static/media/error_boundary_default.6b96d1e99b7f50289806dc6293be2fa6.svg";
export { ForwardRef as ReactComponent };